import { render } from "./MiniLoader.vue?vue&type=template&id=635112af"
import script from "./MiniLoader.vue?vue&type=script&lang=js"
export * from "./MiniLoader.vue?vue&type=script&lang=js"

import "./MiniLoader.vue?vue&type=style&index=0&id=635112af&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__